export const priorExperienceOptions = [
  {
    label: 'common.experience.primarySchool',
    key: 'expPrimaryAssessmentFlag',
  },
  {
    label: 'common.experience.collegeAdmission',
    key: 'expCollegeAssessmentFlag',
  },
  {
    label: 'common.experience.professionalSchool',
    key: 'expGradAdmissionFlag',
  },
  {
    label: 'common.experience.professionalCertificate',
    key: 'expCertLicenseFlag',
  },
  {
    label: 'common.experience.computerBased',
    key: 'expCbtFlag',
  },
];

export const testsAdministrationOptions = [
  {
    label: 'profile.administerOptions.1',
    key: '1-2 per year',
    value: 1,
  },
  {
    label: 'profile.administerOptions.2',
    key: '3-5 per year',
    value: 3,
  },
  {
    label: 'profile.administerOptions.3',
    key: '6-10 per year',
    value: 6,
  },
  {
    label: 'profile.administerOptions.4',
    key: 'More than 10 per year',
    value: 11,
  },
];
